import { Box, Tooltip } from '@mui/material';
import React from 'react';

import CustomButton from '../Button';
import type { ActionButton } from './types';

export interface PageHeaderActionButtonsProps {
  buttons: ActionButton[];
}

const PageHeaderActionButtons: React.FC<PageHeaderActionButtonsProps> = ({
  buttons,
}) => {
  if (buttons.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.625,
        minHeight: 40,
      }}
    >
      {buttons.map((btn, index) => (
        <Tooltip key={btn.label + index} title={btn.tooltip ?? ''}>
          <span>
            <CustomButton
              variant={btn.variant ?? 'contained'}
              size="small"
              color={btn.color ?? 'primary'}
              disabled={btn.disabled}
              loading={btn.loading}
              startIcon={btn.startIcon}
              onClick={btn.onClick}
            >
              {btn.label}
            </CustomButton>
          </span>
        </Tooltip>
      ))}
    </Box>
  );
};

export default PageHeaderActionButtons;
